export enum OtpInputMode {
  NONE = 'none',
  TEXT = 'text',
  DECIMAL = 'decimal',
  NUMERIC = 'numeric',
  TEL = 'tel',
  SEARCH = 'search',
  EMAIL = 'email',
  URL = 'url',
}

export enum OtpInputType {
  TEXT = 'text',
  PASSWORD = 'password',
}

export enum OtpEnterKeyHint {
  DONE = 'done',
  NEXT = 'next',
}

export enum OtpAutoComplete {
  ONE_TIME_CODE = 'one-time-code',
  OFF = 'off',
}

export enum OtpCellPattern {
  NUMERIC = '[0-9]*',
  ALPHANUMERIC = '[A-Za-z0-9]*',
}
